import { useQuery } from "@tanstack/react-query";
import { BarChart3 } from "lucide-react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";
import api from "@/lib/api";

const COLORS = ["#1d4ed8", "#0f766e", "#b45309", "#7e22ce", "#be123c", "#334155", "#0891b2", "#4d7c0f"];
const inr = (v) => v >= 1e7 ? `₹${(v / 1e7).toFixed(2)} Cr` : v >= 1e5 ? `₹${(v / 1e5).toFixed(1)} L` : `₹${Math.round(v).toLocaleString("en-IN")}`;

export function InventoryCategoryChart() {
  const q = useQuery({ queryKey: ["scm-stock-wh"], queryFn: async () => (await api.get("/scm/stock/by-warehouse")).data });
  const c = q.data?.chart;
  if (!c || !c.categories?.length) return null;
  const whs = c.warehouses.filter((w) => c.categories.some((r) => r[w]));
  return (
    <section className="pp-card p-4" data-testid="inventory-category-chart">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-2">
        <div className="pp-label flex items-center gap-2"><BarChart3 size={14} /> Stock value by category × warehouse (GOOD stock)</div>
        <div className="font-mono text-sm font-bold" data-testid="inventory-chart-total">{inr(c.total)}</div>
      </div>
      <div className="h-64" data-testid="inventory-chart-canvas">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={c.categories} margin={{ top: 4, right: 8, left: 8, bottom: 4 }} barCategoryGap="30%">
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
            <XAxis dataKey="category" tick={{ fontSize: 11 }} interval={0} />
            <YAxis tickFormatter={inr} tick={{ fontSize: 10 }} width={72} />
            <Tooltip formatter={(v, n) => [inr(v), n]} labelStyle={{ fontWeight: 700 }} contentStyle={{ fontSize: 12 }} />
            {whs.length > 1 && <Legend wrapperStyle={{ fontSize: 11 }} />}
            {whs.map((w, i) => <Bar key={w} dataKey={w} name={w} stackId="v" fill={COLORS[i % COLORS.length]} radius={i === whs.length - 1 ? [3, 3, 0, 0] : 0} />)}
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-600" data-testid="inventory-chart-legend">
        {c.categories.map((r) => <span key={r.category}><b>{r.category}</b> {inr(r.total)} <span className="text-slate-400">({c.total ? Math.round(r.total / c.total * 100) : 0}%)</span></span>)}
      </div>
    </section>
  );
}
